<template>
    <div class="wrapper d-flex align-items-center mb-5">
        <skeleton-wrapper :is-loading="isLoading">
            <template v-slot:skeleton>
                <next-learning-unit-skeleton />
            </template>
            <template v-slot:content>
                <div class="w-100">
                    <next-learning-unit
                        v-if="isStream"
                        :label="trans('widgets.next_learning.label')"
                        :title="stream.title"
                        :imgSrc="stream.image"
                        :buttonLinkText="trans('widgets.next_learning.go_to')"
                        :completed-steps="stream.progress.unit.completed"
                        :total-steps="stream.progress.unit.count"
                        @onViewStreamClick="openStream()"
                    >
                        <dashboard-card
                            :icon="setCardIcon(stream.progress.current)"
                            :completed="false"
                            :type="cardElementType(stream.progress.current.miu_type, stream.progress.current.type)"
                            :title="stream.progress.current.title"
                            :options="stream.progress.current.softskills"
                            :is-loading="false"
                            @onCta="openStreamElement()"
                        >
                            <component
                                :is="parseContent(stream.progress.current.type)"
                                :time-to-complete="stream.progress.current.time_to_complete"
                                :scheduled="stream.progress.current.scheduled"
                                @onCta="status => openStreamElement(status)"
                            />
                        </dashboard-card>
                    </next-learning-unit>
                
                    <next-learning-unit
                        v-else
                        :label="trans('widgets.next_learning.label')"
                        :title="master.title"
                        :imgSrc="master.image"
                        :progressPercents="master.progress.percentage"
                    >
                        <div class="d-flex flex-column">
                            <p>{{master.description}}</p>
                            <b-button variant="secondary" class="align-self-end" size="sm" @click="openProgram">
                                {{trans('widgets.next_learning.cta')}}
                            </b-button>
                        </div>
                    </next-learning-unit>
                </div>
            </template>
        </skeleton-wrapper>
    </div>
</template>

<script>
    import DashboardCard from "../../../molecules/DashboardCard"
    import RadialProgress from "../../../molecules/RadialProgress"
    import NextLearningUnit from "../../../molecules/NextLearningUnit"
    import streamMixin from "../../../mixins/streamMixin";
    import roleMixin from "../../../mixins/roleMixin";
    import MissionCardContent from "../../stream-dashboard/MissionCardContent";
    import MiuCardContent from "../../stream-dashboard/MiuCardContent";
    import { mapMutations } from "vuex";
    import SkeletonWrapper from "../../SkeletonWrapper";
    import NextLearningUnitSkeleton from "../../../molecules/skeletons/NextLearningUnitSkeleton";

    export default {
        name: "NextLearningUnitContainer",
        components: {
            DashboardCard,
            RadialProgress,
            NextLearningUnit,
            MissionCardContent,
            MiuCardContent,
            SkeletonWrapper,
            NextLearningUnitSkeleton
        },
        data () {
            return {
                isLoading: true,
                isStream: null,
                stream: {},
                master: {}
            }
        },
        methods: {
            ...mapMutations({
                setCurrentAle: 'streams/setCurrentAle'
            }),
            goToNextUnit(trackData) {
                trackEvent('NextSessionStartNow', {...trackData})
            },
            openStream() {
                this.accessService(this.stream.progress.current.streamId, 'stream', 'stream');
                trackEvent('CheckStreamDashboard', this.streamTrackData)
            },
            openStreamElement(status){
                const element = {
                    type: this.stream.progress.current.type,
                    id: this.stream.progress.current.id
                }

                this.$router.push(this.itemRoute(this.stream.progress.current.streamId, this.stream.progress.current.aleId, this.stream.progress.current.locale, element, status ? status : ''));
                this.goToNextUnit(this.streamTrackData);

                this.ifTypeOpenOrWebinar(this.stream.progress.current.status, this.stream.progress.current.type);
                this.setCurrentAle(this.stream.ale); 
            },
            openProgram() {
                this.accessService(this.master.id, this.master.type, this.master.type);
                trackEvent('CheckProgramDashboard', this.master)
            },
            parseContent(type){
                switch (type.toLowerCase()) {
                    case 'mission': {
                        return 'mission-card-content'
                    }
                    default: {
                        return 'miu-card-content'
                    }
                }
            },
        },
        computed: {
            streamTrackData() {
                return {
                    streamId: this.stream.progress.current.streamId,
                    streamName: this.stream.title,
                    aleId: this.stream.progress.current.aleId,
                    elementId: this.stream.progress.current.id
                }
            },
            programTrackData() {
                return {
                    courseName: this.master.title,
                    courseId: this.master.id
                }
            }
        },
        mounted() {
            this.$axios.get('/api/rest/home/nextStep')
                .then(res => {
                    this.isStream = res.data.type === 'stream';
                    
                    if (this.isStream) {
                        this.stream = res.data
                    } else {
                        this.master = res.data
                    }

                    this.isLoading = false;
                }).catch(err => {
                    console.log(err);
                    this.isLoading = false;
                });
        },
        mixins: [streamMixin, roleMixin]
    }
</script>

<style scoped>
    .wrapper {
        min-height: 300px;
    }
</style>